import { Style, Circle as CircleStyle, Fill, Stroke, Text, RegularShape } from 'ol/style';
import { fromLonLat } from 'ol/proj';
import { Point } from 'ol/geom';
import Feature from 'ol/Feature';
import { getCountry } from './mapevents.js';

export function cloneStyle3(style) {
  if (style instanceof Function) {
    return style;
  }
  if (Array.isArray(style)) {
    return style.map((s) => (s instanceof Function ? s : s.clone()));
  }
  return style.clone();
}

export function cloneStyle(style) {
  if (!(style instanceof Function)) {
    style = style.clone();
  }
  return style;
}

export const styleGraticule = new Stroke({
  color: 'rgba(0,0,0,0.9)',
  width: 2,
  lineDash: [0.5, 4],
});

export const styleInnerDistance = new Style({
  stroke: new Stroke({
    color: 'white', // Color of the stroke
    width: 1, // Width of the stroke
    lineDash: [4, 3],
  }),
});
export const styleShadowDistance = new Style({
  stroke: new Stroke({
    color: 'red', // Black with some opacity
    width: 2, // Increase the width for better visual effect
  }),
});

export const styleText = (feature) => {
  let style = new Text({
    text: `${feature?.get('label')}`,
    font: '12px Calibri,sans-serif',
    offsetY: 15,
    fill: new Fill({
      color: 'black',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 3,
    }),
  });
  return style;
};

export const styleDraw = new Style({
  fill: new Fill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new Stroke({
    color: 'rgba(0, 0, 0, 0.5)',
    lineDash: [10, 10],
    width: 2,
  }),
  image: new CircleStyle({
    radius: 5,
    stroke: new Stroke({
      color: 'rgb(255, 255, 255)', //'rgba(0, 0, 0, 0.7)',
    }),
    fill: new Fill({
      color: 'rgb(51, 153, 255)', //'rgba(255, 255, 255, 0.2)',
    }),
  }),
});

export const styleDistance = [styleShadowDistance, styleInnerDistance];

// export const pointStyle1 = new Style({
//   image: new CircleStyle({
//     radius: 5,
//     fill: new Fill({ color: 'white' }),
//     stroke: new Stroke({
//       color: [255, 0, 0],
//       width: 2,
//     }),
//   }),
// });

export const styleSites = (feature) => {
  return new Style({
    image: new CircleStyle({
      radius: 5,
      fill: new Fill({ color: 'white' }),
      stroke: new Stroke({
        color: [255, 0, 0],
        width: 2,
      }),
    }),
    text: new Text({
      text: `${feature?.get('siteCode')}`,
      font: '10px Calibri,sans-serif',
      offsetY: 15,
      fill: new Fill({
        color: 'black',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 3,
      }),
    }),
  });
};

export const styleAssgnSpratly = (feature) => {
  return new Style({
    image: new CircleStyle({
      radius: 5,
      fill: new Fill({ color: 'white' }),
      stroke: new Stroke({
        color: [0, 0, 0],
        width: 2,
      }),
    }),
    text: new Text({
      text: `${feature?.get('site_name')}`,
      font: '10px Calibri,sans-serif',
      offsetY: 15,
      fill: new Fill({
        color: 'black',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 3,
      }),
    }),
  });
};

// export const styleAssgnSpratlyTPR = (feature) => {
//   return new Style({
//     image: new CircleStyle({
//       radius: 5,
//       fill: new Fill({ color: 'white' }),
//       stroke: new Stroke({
//         color: [0, 0, 255],
//         width: 1,
//       }),
//     }),
//     text: new Text({
//       text: `${feature?.get('site_name')}`,
//       font: '10px Calibri,sans-serif',
//       offsetY: 15,
//       fill: new Fill({
//         color: 'black',
//       }),
//       stroke: new Stroke({
//         color: '#fff',
//         width: 1,
//       }),
//     }),
//   });
// };

export const styleAssgnSpratlyPending = (feature) => {
  return new Style({
    image: new CircleStyle({
      radius: 5,
      fill: new Fill({ color: 'white' }),
      stroke: new Stroke({
        color: [255, 0, 0],
        width: 1,
      }),
    }),
    text: new Text({
      text: `${feature?.get('site_name')}`,
      font: '10px Calibri,sans-serif',
      offsetY: 15,
      fill: new Fill({
        color: 'black',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 1,
      }),
    }),
  });
};

export const styleUNMapSpratly = (feature) => {
  // console.log(`${feature.id_}`);
  // console.log(`${feature}`);
  // window.feature = feature;

  let featureId = `${feature.id_}`;
  let idWithoutIsland = featureId.replace('islands.', 'UN-');

  return new Style({
    fill: new Fill({
      color: 'rgba(245, 245, 220, 1)',
    }),
    stroke: new Stroke({
      color: 'rgba(255,0,0,1)',
      width: 1,
    }),
    text: new Text({
      text: idWithoutIsland,
      font: 'bold 14px Calibri,sans-serif',
      //offsetY: 15,
      fill: new Fill({
        color: 'black',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 3,
      }),
    }),
  });
};

export const styleIdwm = (feature) => {
  return new Style({
    fill: new Fill({
      color: 'rgba(245, 245, 220, 1)',
    }),
    stroke: new Stroke({
      color: 'rgba(55,55,50,1)',
      width: 1,
    }),
    text: new Text({
      text: `${getCountry(feature)}`,
      font: '10px Calibri,sans-serif',
      //offsetY: 15,
      fill: new Fill({
        color: 'black',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 3,
      }),
    }),
  });
};

export const styleLakes = (feature) => {
  return new Style({
    fill: new Fill({
      color: 'rgba(73,207,245,1)',
    }),
    stroke: new Stroke({
      //color: 'rgba(55,55,50,1)',
      width: 0.75,
    }),
    // text: new Text({
    //   text: `${feature?.getId()?.replace('idwm_Lakes.', '')}`,
    //   font: '11px Calibri,sans-serif',
    //   //offsetY: 15,
    //   fill: new Fill({
    //     color: 'black',
    //   }),
    //   stroke: new Stroke({
    //     color: '#fff',
    //     width: 3,
    //   }),
    // }),
  });
};

export const styleSea = (feature) => {
  return new Style({
    fill: new Fill({
      color: 'rgba(14,152,224,1)',
    }),
    stroke: new Stroke({
      //color: 'rgba(55,55,50,1)',
      width: 0.75,
    }),
    // text: new Text({
    //   text: `${feature?.getId()?.replace('idwm_Lakes.', '')}`,
    //   font: '11px Calibri,sans-serif',
    //   //offsetY: 15,
    //   fill: new Fill({
    //     color: 'black',
    //   }),
    //   stroke: new Stroke({
    //     color: '#fff',
    //     width: 3,
    //   }),
    // }),
  });
};

export const styleUNMaps = (feature) => {
  return new Style({
    fill: new Fill({
      color: 'rgba(170,170,170,1)',
    }),
    stroke: new Stroke({
      color: 'rgba(55,55,50,1)',
      width: 0.75,
    }),
    text: new Text({
      text: `${feature?.get('ISO3CD')}`,
      font: '11px Calibri,sans-serif',
      //offsetY: 15,
      fill: new Fill({
        color: 'black',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 3,
      }),
    }),
  });
};

function createTextStyle7475(text, location) {
  const textStyle = new Style({
    text: new Text({
      text: text,
      font: '13px Calibri,sans-serif',
      fill: new Fill({
        color: 'red',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 4,
      }),
    }),
    geometry: new Point(location),
  });
  return textStyle;
}

const locationTextC75 = fromLonLat([-6.103412, 82.924541]);
const locationTextC74 = fromLonLat([-6.103412, -82.924541]);
const textStyleC75 = createTextStyle7475('C-75', locationTextC75);
const textStyleC74 = createTextStyle7475('C-74', locationTextC74);

const styleCirafBorder = new Style({
  stroke: new Stroke({
    color: 'white', // Color of the stroke
    width: 1, // Width of the stroke
    lineDash: [4, 3],
  }),
});
const styleCirafShadow = new Style({
  stroke: new Stroke({
    color: 'grey', // Black with some opacity
    width: 2, // Increase the width for better visual effect
  }),
});

export const styleCirafZones = (feature) => {
  let cirafLabelStyle;
  let id = feature?.get('zone_id');

  if (id == 75) {
    cirafLabelStyle = textStyleC75;
  } else if (id == 74) {
    cirafLabelStyle = textStyleC74;
  } else {
    cirafLabelStyle = new Style({
      text: new Text({
        text: `C-${id}`,
        font: '13px Calibri,sans-serif',
        fill: new Fill({
          color: 'red',
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 4,
        }),
      }),
    });
  }

  return [styleCirafShadow, styleCirafBorder, cirafLabelStyle];
};

export const styleCirafQuadrant = (feature) => {
  const zoneId = feature?.get('zoneID')?.toString();

  const style = new Style({
    stroke: new Stroke({
      color: 'rgba(0, 255, 255, 1)',
      width: 1,
      lineDash: [4, 3],
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 0,0)',
    }),
    text: new Text({
      text: `Q-${zoneId}`,
      font: '13px Calibri,sans-serif',
      fill: new Fill({
        color: 'black',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 4,
      }),
    }),
  });

  return style;
};

export const transparentFill = new Fill({
  color: 'rgba(255, 0, 0, 0)',
});

export const transparentStroke = new Stroke({
  color: 'rgba(255, 0, 0, 0)',
});

/**
 * Creates a new OpenLayers style that represents a red star.
 * This is the default style used if no user-defined style is provided.
 *
 * @returns {ol.style.Style} The resulting style
 */
export const styleStar = (feature) => {
  return new Style({
    image: new RegularShape({
      points: 5,
      radius: 7,
      radius2: 4,
      stroke: new Stroke({
        color: 'red',
        width: 1,
      }),
      fill: new Fill({
        color: 'red',
      }),
    }),
    text: styleText(feature),
  });
};

/**
 * Creates a new OpenLayers style that represents a red polygon.
 * This is the default style used if no user-defined style is provided.
 *
 * @returns {ol.style.Style} The resulting style
 */
export const stylePolygon = new Style({
  fill: new Fill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new Stroke({
    color: 'red',
    width: 2,
  }),
});

export const styleHighlight = new Style({
  fill: new Fill({
    color: 'rgba(205, 92, 92, 0.1)', // Red highlight
  }),
  stroke: new Stroke({
    color: '#000000',
    width: 1,
  }),
});

export const selectStyle = new Style({
  image: new CircleStyle({
    radius: 7,
    fill: new Fill({ color: '#00ffff' }),
    stroke: new Stroke({ color: 'white', width: 2 }),
  }),
});

export const createSelectStyle = (fillColor, selectColor) =>
  new Style({
    image: new RegularShape({
      fill: new Fill({
        color: fillColor,
      }),
      radius: 10,
      points: 3,
      stroke: new Stroke({
        color: selectColor,
        width: 2,
      }),
    }),
  });

export function getFillColorFromLayer(layer) {
  function getFillColor(style) {
    let color = null;
    let fill = style.getFill();
    let image = style.getImage();
    if (fill) {
      color = fill.getColor();
    } else if (image) {
      color = image.getFill().getColor();
    }
    return color;
  }
  let fillColor = null;
  const layerStyle = layer.getStyle();
  const styleFunction = layer.getStyleFunction();
  if (styleFunction) {
    const dummyFeature = new Feature(); // Create a dummy feature for evaluation
    const dummyStyle = styleFunction(dummyFeature); // Evaluate the style function
    if (dummyStyle) {
      if (Array.isArray(dummyStyle) && dummyStyle.length > 0) {
        fillColor = getFillColor(dummyStyle[0]);
      } else {
        fillColor = getFillColor(dummyStyle);
      }
    }
  } else if (layerStyle) {
    fillColor = getFillColor(layerStyle);
  }

  if (!fillColor) {
    fillColor = '#00ffff'; // cyan
  }

  return fillColor;
}

export function getStyleForJsonLayer(style) {
  if (style instanceof Style) {
    return style;
  }

  let defaultStyle = new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 0.5,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 238, 0.1)',
    }),
  });
  style = style ? getolStyle(style) : defaultStyle;
  return style;
}

export function getStyleFromString(styleString) {
  let line, point, triangle, square, star, cross, diamond, contour;
  styleString = styleString?.replace(/\s+/g, ' ')?.trim();
  let [shape, color, size, fontSize] = styleString.split(' ');
  size = size ? Number(size) : undefined;
  fontSize = Number(fontSize);
  let objStyle = { radius: size, fill: { color: color }, stroke: { color: 'black', width: 1 } };
  switch (shape) {
    case 'line':
      line = {
        stroke: { color: color, width: size },
      };
      break;
    case 'contour':
      contour = {
        stroke: { color: color, width: size },
        // fill: { color: 'rgba(238, 0, 0, 0.3)' },
        fill: { color: 'rgba(0, 0, 238, 0.1)' },
      };
      break;
    case 'point':
      point = objStyle;
      break;
    case 'triangle':
      triangle = objStyle;
      break;
    case 'square':
      square = objStyle;
      break;
    case 'star':
      star = objStyle;
      break;
    case 'cross':
      cross = objStyle;
      break;
    case 'diamond':
      diamond = objStyle;
      break;
    default:
      break;
  }
  return {
    line,
    point,
    triangle,
    square,
    star,
    cross,
    diamond,
    contour,
    fontSize,
  };
}

function getBaseConfig({ line, point, triangle, square, star, cross, diamond, contour }) {
  let baseConfigStyle;
  function getRadius2(radius) {
    const quotient = Math.floor(radius / 2);
    const remainder = radius % 2;
    return remainder > 0 ? quotient + 1 : quotient;
  }
  function getShapeConfig({ radius, fill, stroke, nPoints }) {
    return {
      points: nPoints,
      radius: radius,
      fill: new Fill({
        color: fill?.color,
      }),
      stroke: new Stroke({
        color: stroke?.color,
        width: stroke?.width ?? 1,
        lineDash: stroke?.lineDash,
      }),
    };
  }
  function regularShape({ radius, fill, stroke, nPoints }) {
    let radius2 = getRadius2(radius);
    const shapeConfig = getShapeConfig({ radius, fill, stroke, nPoints });
    if (nPoints > 4) {
      shapeConfig.radius2 = radius2;
    }
    return new RegularShape(shapeConfig);
  }
  function createStyleLine({ stroke }) {
    const config = {
      stroke: new Stroke({
        color: stroke?.color,
        width: stroke?.width ?? 1,
        lineDash: stroke?.lineDash,
      }),
    };
    return config;
  }
  function createCircleStyle({ radius, fill, stroke }) {
    const config = {
      image: new CircleStyle({
        radius: radius,
        fill: new Fill({
          color: fill?.color,
        }),
        stroke: new Stroke({
          color: stroke?.color,
          width: stroke?.width ?? 1,
          lineDash: stroke?.lineDash,
        }),
      }),
    };
    return config;
  }
  function createStyleCross({ radius, fill, stroke }) {
    const shapeConfig = getShapeConfig({ radius, fill, stroke, nPoints: 3 });
    shapeConfig.radius2 = null;
    const config = {
      image: new RegularShape(shapeConfig),
    };
    return config;
  }
  function createStyleTriangle({ radius, fill, stroke }) {
    const config = {
      image: regularShape({ radius, fill, stroke, nPoints: 3 }),
    };
    return config;
  }
  function createStyleStar({ radius, fill, stroke }) {
    const config = {
      image: regularShape({ radius, fill, stroke, nPoints: 5 }),
    };
    return config;
  }
  function createStyleSquare({ radius, fill, stroke }) {
    const shapeConfig = getShapeConfig({ radius, fill, stroke, nPoints: 4 });
    shapeConfig.angle = Math.PI / 4;
    const config = {
      image: new RegularShape(shapeConfig),
    };
    return config;
  }
  function createStyleDiamond({ radius, fill, stroke }) {
    const config = {
      image: regularShape({ radius, fill, stroke, nPoints: 4 }),
    };
    return config;
  }
  function createContourStyle({ fill, stroke }) {
    const config = {
      stroke: new Stroke({
        color: stroke?.color,
        width: stroke?.width ?? 1,
        lineDash: stroke?.lineDash,
      }),
      fill: new Fill({
        color: fill?.color,
      }),
    };
    return config;
  }
  if (line) {
    baseConfigStyle = createStyleLine(line);
  } else if (contour) {
    baseConfigStyle = createContourStyle(contour);
  } else if (point) {
    baseConfigStyle = createCircleStyle(point);
  } else if (triangle) {
    baseConfigStyle = createStyleTriangle(triangle);
  } else if (square) {
    baseConfigStyle = createStyleSquare(square);
  } else if (star) {
    baseConfigStyle = createStyleStar(star);
  } else if (cross) {
    baseConfigStyle = createStyleCross(cross);
  } else if (diamond) {
    baseConfigStyle = createStyleDiamond(diamond);
  }
  return baseConfigStyle;
}

export function getolStyle(style, hasLabels, size) {
  if (style instanceof Style) {
    return style;
  }

  let fontSize;
  let line, point, triangle, square, star, cross, diamond, font, contour;
  if (typeof style === 'string') {
    ({ line, point, triangle, square, star, cross, diamond, contour, fontSize } = getStyleFromString(style));
  } else if (typeof style === 'object') {
    ({ line, point, triangle, square, star, cross, diamond, contour, font } = style);
    fontSize = Number(font?.size);
  }

  if (!fontSize || isNaN(fontSize)) {
    fontSize = 12;
  }

  let baseConfigStyle = getBaseConfig({ line, point, triangle, square, star, cross, diamond, contour });

  const text = (feature) => {
    return new Text({
      text: `${feature?.get('label')}`,
      font: `${fontSize}px Calibri,sans-serif`,
      offsetY: 15,
      fill: new Fill({
        color: 'black',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 3,
      }),
    });
  };

  const textCluster = (size) => {
    return new Text({
      text: size.toString(),
      fill: new Fill({
        color: '#fff',
      }),
    });
  };

  if (hasLabels) {
    if (size) {
      let textStyle = textCluster(size);
      baseConfigStyle['text'] = textStyle;
      return new Style(baseConfigStyle);
    } else {
      const styleResult = (feature) => {
        baseConfigStyle['text'] = text(feature);
        return new Style(baseConfigStyle);
      };
      return styleResult;
    }
  } else {
    return new Style(baseConfigStyle);
  }
}

export const pointCoordsStyle = new Style({
  image: new RegularShape({
    points: 5,
    radius: 5,
    radius2: 2,
    stroke: new Stroke({
      color: 'red',
      width: 1,
    }),
    fill: new Fill({
      color: 'red',
    }),
  }),
});

export const styleCluster = (feature, styleCache, _styles) => {
  let size = 1;
  let group = null;
  let style = null;
  const cfeatures = feature.get('features');
  if (cfeatures && cfeatures.length >= 1) {
    size = cfeatures.length;
    group = cfeatures[0].get('group');
  }
  group = group ?? 'all';

  let cached = group + ':' + size;

  style = styleCache[cached];
  if (!style) {
    if (_styles && _styles[group]) {
      style = getolStyle(_styles[group], true, size);
    } else {
      style = getStyleClusterDefault(size);
    }
    styleCache[cached] = style;
  }

  return style;
};

export const styleCluster2 = (feature) => {
  const features = feature.get('features'); // Get the features in the cluster
  const size = features.length; // Number of features in the cluster

  // Calculate circle radius based on cluster size
  const radius = Math.min(10 + Math.log(size + 1) * 5, 30); // Cap radius at 30px

  return new Style({
    image: new CircleStyle({
      radius: radius, // Scaled circle radius
      fill: new Fill({ color: '#ff5733' }), // Circle fill color
      stroke: new Stroke({
        color: '#fff', // White border for contrast
        width: 2,
      }),
    }),
    text: new Text({
      text: size.toString(), // Display the cluster size
      font: '14px sans-serif',
      fill: new Fill({ color: '#fff' }), // White text
      stroke: new Stroke({
        color: '#333', // Text outline for better visibility
        width: 3,
      }),
    }),
  });
};

function getStyleClusterDefault(size) {
  let style = new Style({
    image: new CircleStyle({
      radius: 10,
      stroke: new Stroke({
        color: 'black',
      }),
      fill: new Fill({
        color: '#78cc33',
      }),
    }),
    text: new Text({
      text: size.toString(),
      fill: new Fill({
        color: '#fff',
      }),
    }),
  });
  return style;
}

// export const styleCluster2 = (feature, styles) => {
//   const features = feature.get('features');
//   const size = features.length;
//   const group = features[0].get('group');
//   const text = new Text({
//     text: size.toString(),
//     fill: new Fill({
//       color: '#fff',
//     }),
//   });
//   let image = new CircleStyle({
//     radius: 10,
//     stroke: new Stroke({
//       color: 'black',
//     }),
//     fill: new Fill({
//       color: '#78cc33',
//     }),
//   })
//   let sts=
//   if (group) {
//     if (styles[group]) {
//       let stl = styles[group];
//       image=getBaseConfig({});
//     }
//   }
//   let style = new Style({
//     image:image ,
//     text: text,
//   });
//   return style;
// };
